var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25891)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.219971,
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#paint0_linear_1_25891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2192 29.9976C58.2192 14.5336 45.6832 1.99756 30.2192 1.99756C14.7553 1.99756 2.21924 14.5336 2.21924 29.9976C2.21924 45.4615 14.7553 57.9976 30.2192 57.9976C45.6832 57.9976 58.2192 45.4615 58.2192 29.9976Z",
    fill: "url(#paint1_linear_1_25891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.22 57C15.3204 57 3.21997 44.8822 3.21997 30C3.21997 15.1178 15.3378 3 30.22 3C45.1021 3 57.22 15.1178 57.22 30C57.22 44.8822 45.1021 57 30.22 57Z",
    fill: "url(#paint2_linear_1_25891)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1_25891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0697 18.4202C24.0697 21.7814 21.3522 24.4989 17.991 24.4989C14.6299 24.4989 11.9124 21.7814 11.9124 18.4202C11.9124 15.0591 14.6299 12.3416 17.991 12.3416C21.3522 12.3416 24.0697 15.0591 24.0697 18.4202Z",
    fill: "url(#paint3_linear_1_25891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9697 18.4202C23.9697 21.7261 21.2969 24.3989 17.991 24.3989C14.6851 24.3989 12.0124 21.7261 12.0124 18.4202C12.0124 15.1143 14.6851 12.4416 17.991 12.4416C21.2969 12.4416 23.9697 15.1143 23.9697 18.4202Z",
    stroke: "white",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_1_25891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5274 18.4202C48.5274 21.7814 45.8099 24.4989 42.4488 24.4989C39.0876 24.4989 36.3701 21.7814 36.3701 18.4202C36.3701 15.0591 39.0876 12.3416 42.4488 12.3416C45.8099 12.3416 48.5274 15.0591 48.5274 18.4202Z",
    fill: "url(#paint4_linear_1_25891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4274 18.4202C48.4274 21.7261 45.7547 24.3989 42.4488 24.3989C39.1429 24.3989 36.4701 21.7261 36.4701 18.4202C36.4701 15.1143 39.1429 12.4416 42.4488 12.4416C45.7547 12.4416 48.4274 15.1143 48.4274 18.4202Z",
    stroke: "white",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_1_25891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0697 42.0198C24.0697 45.381 21.3522 48.0985 17.991 48.0985C14.6299 48.0985 11.9124 45.381 11.9124 42.0198C11.9124 38.6587 14.6299 35.9412 17.991 35.9412C21.3522 35.9412 24.0697 38.6587 24.0697 42.0198Z",
    fill: "url(#paint5_linear_1_25891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9697 42.0198C23.9697 45.3257 21.2969 47.9985 17.991 47.9985C14.6851 47.9985 12.0124 45.3257 12.0124 42.0198C12.0124 38.7139 14.6851 36.0412 17.991 36.0412C21.2969 36.0412 23.9697 38.7139 23.9697 42.0198Z",
    stroke: "white",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_1_25891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5274 42.0198C48.5274 45.381 45.8099 48.0985 42.4488 48.0985C39.0876 48.0985 36.3701 45.381 36.3701 42.0198C36.3701 38.6587 39.0876 35.9412 42.4488 35.9412C45.8099 35.9412 48.5274 38.6587 48.5274 42.0198Z",
    fill: "url(#paint6_linear_1_25891)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4274 42.0198C48.4274 45.3257 45.7547 47.9985 42.4488 47.9985C39.1429 47.9985 36.4701 45.3257 36.4701 42.0198C36.4701 38.7139 39.1429 36.0412 42.4488 36.0412C45.7547 36.0412 48.4274 38.7139 48.4274 42.0198Z",
    stroke: "white",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1_25891",
    x: 9.91235,
    y: 10.3416,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25891",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25891"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_1_25891",
    x: 34.3701,
    y: 10.3416,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25891",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25891"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_1_25891",
    x: 9.91235,
    y: 33.9412,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25891",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25891"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_1_25891",
    x: 34.3701,
    y: 33.9412,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25891",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25891"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_25891",
    x1: 59.4512,
    y1: 59.2312,
    x2: 0.988744,
    y2: 0.768773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_25891",
    x1: 11.6886,
    y1: 11.4669,
    x2: 49.1889,
    y2: 48.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_25891",
    x1: 50.3689,
    y1: 49.6627,
    x2: 9.04013,
    y2: 10.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA2228"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_25891",
    x1: 21.5665,
    y1: 22.7289,
    x2: 14.2109,
    y2: 13.6401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_25891",
    x1: 46.0243,
    y1: 22.7289,
    x2: 38.6687,
    y2: 13.6401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_25891",
    x1: 21.5665,
    y1: 46.3285,
    x2: 14.2109,
    y2: 37.2397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_25891",
    x1: 46.0243,
    y1: 46.3285,
    x2: 38.6687,
    y2: 37.2397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.219971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4);
export default __webpack_public_path__ + "static/media/b4.af08c1d7c92edc4ebd5582bb8db51bf5.svg";
export { ForwardRef as ReactComponent };